import { EnrollmentConfigState } from "@pages/Contents/V2/Corporate/Catalog/Enrollment/types";
import { buildInitialConfig } from "@pages/Contents/V2/Corporate/Catalog/Enrollment/config/enrollmentFieldsConfig";

export interface GroupLoSelection {
  id: number;
  type: string;
}

export interface EnrollmentStepData {
  loSelections: GroupLoSelection[];
  enrollConfig: EnrollmentConfigState;
}

export interface StaticGroupWizardData extends EnrollmentStepData {
  name: string;
  description: string;
  userIds: number[];
  pendingCsvFile?: File | null;
}

export const buildInitialEnrollConfig = (): EnrollmentConfigState => ({
  ...buildInitialConfig(),
  enrollType: "TOP",
});

export const INITIAL_GROUP_WIZARD_DATA: StaticGroupWizardData = {
  name: "",
  description: "",
  userIds: [],
  loSelections: [],
  enrollConfig: buildInitialEnrollConfig(),
  pendingCsvFile: null,
};
